import { createBrowserRouter } from "react-router-dom";
import { Layout } from "./layout/Layout";
import { RequireSuperuser } from "@/components/RequireSuperuser";
import { RedirectIfAuthenticated } from "@/components/RedirectIfAuthenticated";
import Home from "./pages/Home";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import CreateProduct from "./pages/CreateProduct";
import EditProduct from "./pages/EditProduct";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import VerifyEmail from "./pages/VerifyEmail";
import NotFound from "./pages/NotFound";
import { ProductFormSkeleton } from "@/components/ui/ProductForm";

export const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      { path: "/", element: <Home /> },
      {
        path: "/login",
        element: (
          <RedirectIfAuthenticated>
            <Login />
          </RedirectIfAuthenticated>
        ),
      },
      {
        path: "/register",
        element: (
          <RedirectIfAuthenticated>
            <Register />
          </RedirectIfAuthenticated>
        ),
      },
      {
        path: "/forgot-password",
        element: (
          <RedirectIfAuthenticated>
            <ForgotPassword />
          </RedirectIfAuthenticated>
        ),
      },
      {
        path: "/reset-password",
        element: (
          <RedirectIfAuthenticated>
            <ResetPassword />
          </RedirectIfAuthenticated>
        ),
      },
      { path: "/verify-email", element: <VerifyEmail /> },
      { path: "/products", element: <Products /> },
      {
        path: "/products/new",
        element: (
          <RequireSuperuser fallback={<ProductFormSkeleton />}>
            <CreateProduct />
          </RequireSuperuser>
        ),
      },
      { path: "/product/:slug/p/:public_id", element: <ProductDetail /> },
      {
        path: "/product/:slug/p/:public_id/edit",
        element: (
          <RequireSuperuser fallback={<ProductFormSkeleton />}>
            <EditProduct />
          </RequireSuperuser>
        ),
      },
      { path: "*", element: <NotFound /> },
    ],
  },
]);
